import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import { loadPiiReport, downloadReport } from '../../data-dictionary-view.actions';
import ReportShell from './report-shell';

const SENSITIVITY_OPTIONS = ['Restricted', 'Confidential', 'Internal', 'Public'];

class PiiReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sensitivity: '',
      schema: '',
      search: '',
    };
  }

  componentDidMount() {
    this.loadReport();
  }

  loadReport = () => {
    const { sensitivity, schema, search } = this.state;
    this.props.loadPiiReport({ sensitivity, schema, search });
  }

  handleFilterChange = (field) => (e) => {
    this.setState({ [field]: e.target.value }, this.loadReport);
  }

  handleDownload = () => {
    const { sensitivity, schema, search } = this.state;
    this.props.downloadReport('pii', { sensitivity, schema, search });
  }

  handleCardClick = (key) => {
    const current = this.state.sensitivity;
    const next = (key === 'total' || current === key) ? '' : key;
    this.setState({ sensitivity: next }, this.loadReport);
  }

  getSummaryTiles(data, summary) {
    const counts = summary || data.reduce((acc, r) => {
      const level = (r.sensitivity || '').toLowerCase();
      if (level === 'restricted') acc.restricted++;
      else if (level === 'confidential') acc.confidential++;
      else if (level === 'internal') acc.internal++;
      else acc.public++;
      return acc;
    }, { restricted: 0, confidential: 0, internal: 0, public: 0 });
    const total = summary ? summary.piiTotal : data.length;
    const { sensitivity } = this.state;
    return [
      { label: 'Total', value: total, className: 'total', key: 'total', isActive: !sensitivity, onClick: () => this.handleCardClick('total') },
      { label: 'Restricted', value: counts.restricted, className: 'rejected', key: 'Restricted', isActive: sensitivity === 'Restricted', onClick: () => this.handleCardClick('Restricted') },
      { label: 'Confidential', value: counts.confidential, className: 'pending', key: 'Confidential', isActive: sensitivity === 'Confidential', onClick: () => this.handleCardClick('Confidential') },
      { label: 'Internal', value: counts.internal, className: 'deferred', key: 'Internal', isActive: sensitivity === 'Internal', onClick: () => this.handleCardClick('Internal') },
      { label: 'Public', value: counts.public, className: 'approved', key: 'Public', isActive: sensitivity === 'Public', onClick: () => this.handleCardClick('Public') },
    ];
  }

  renderFilters() {
    const { sensitivity, schema, search } = this.state;
    const { schemas } = this.props;
    return (
      <div className="dd-view-filter-row">
        <TextField
          select
          label="Sensitivity"
          value={sensitivity}
          onChange={this.handleFilterChange('sensitivity')}
          variant="standard"
          fullWidth
        >
          <MenuItem value="">All</MenuItem>
          {SENSITIVITY_OPTIONS.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
        </TextField>
        <TextField
          select
          label="Schema"
          value={schema}
          onChange={this.handleFilterChange('schema')}
          variant="standard"
          fullWidth
        >
          <MenuItem value="">All</MenuItem>
          {Array.isArray(schemas) && schemas.map(s => (
            <MenuItem key={s.schemaId} value={s.schemaId}>{s.instanceName} ({s.schemaName})</MenuItem>
          ))}
        </TextField>
        <TextField
          label="Search"
          value={search}
          onChange={this.handleFilterChange('search')}
          variant="standard"
          fullWidth
          InputProps={{
            endAdornment: search && (
              <InputAdornment position="end">
                <i className="material-icons search-clear" onClick={() => this.setState({ search: '' }, this.loadReport)}>close</i>
              </InputAdornment>
            )
          }}
        />
      </div>
    );
  }

  renderTable(data) {
    return (
      <div className="object-table-container">
        <table className="object-table">
          <thead>
            <tr>
              <th>Schema</th>
              <th>Table</th>
              <th>Column</th>
              <th>Data Type</th>
              <th>Sensitivity</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx}>
                <td>{row.schema}</td>
                <td>{row.table}</td>
                <td>{row.column}</td>
                <td>{row.dataType}</td>
                <td>
                  <span className={`dd-badge badge-${(row.sensitivity || '').toLowerCase()}`}>
                    {row.sensitivity}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { piiReport, onBack } = this.props;
    const data = piiReport.data || [];
    const summary = piiReport.summary || null;

    return (
      <ReportShell
        title="PII Report"
        icon="security"
        summaryTiles={this.getSummaryTiles(data, summary)}
        filters={this.renderFilters()}
        table={this.renderTable(data)}
        isLoading={piiReport.isLoading}
        error={piiReport.error}
        data={data}
        onBack={onBack}
        onDownload={this.handleDownload}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  piiReport: state.dataDictionaryViewReducer.reports.pii,
  schemas: state.dataDictionaryViewReducer.schemas,
});

export default connect(mapStateToProps, { loadPiiReport, downloadReport })(PiiReport);
